// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1yjif","signatureBlock":"Footer_signatureBlock__2wngO","signature":"Footer_signature__2NmEz"};